import Vue from 'vue'
import VueRouter from 'vue-router'
import dashboard from './routes/dashboard'
import oneID from './routes/one-id'
import categorySubject from './routes/category-subject'
import directionSectorCode from './routes/direction-sector-code'
import country from './routes/country'
import direction from './routes/direction'
import region from './routes/region'
import district from './routes/district'
import organization from './routes/organization'
import organizations from './routes/organizations'
import period from './routes/period'
import auth from './routes/auth'
import users from './routes/users'
import user from './routes/user'
import letter from './routes/letter'
import applyDocument from './routes/apply-document'
import additionalQuote from './routes/additional-quote'
import monitoring from './routes/monitoring'
import orgMonitoring from './routes/org-monitoring'
import applicantDocument from './routes/applicant-document'
import researchAdvisor from './routes/research-advisor'
import studentList from './routes/student-list'
import inbox from './routes/inbox'
import me from '@/router/routes/me'
import applyDocByOrg from '@/router/routes/applyDocByOrg'
import notification from '@/router/routes/notification'
import notificationInbox from '@/router/routes/notification-inbox'
import quoteDistribution from '@/router/routes/quote-distribution'
import exam from '@/router/routes/exam'
import post from '@/router/routes/post'
import { canNavigate } from '@/libs/acl/routeProtection'
import front from './routes/front/front'
import targetedLetters from './routes/targeted-letters'
import applicantDocumentAll from './routes/applicant-document-all'
import additionalExam from './routes/additional-exam'
import pdfViewer from '@/router/routes/pdf-viewer'
import attestationWork from '@/router/routes/attestation-work'
import scientificInformation from '@/router/routes/scientific-information'
import allExams from '@/router/routes/all-exams'
import quoteAgreement from '@/router/routes/quoteAgreement'
import scientificTopics from '@/router/routes/scientific-topics'
import advisorStudents from '@/router/routes/advisor-students'
import settings from '@/router/routes/settings'
import certificate from '@/router/routes/certificate'
import requestLetters from '@/router/routes/request-letters'
import confirmedScientificTopicProtocol from '@/router/routes/confirmed-scientific-topic-protocol'
import confirmedScientificTopic from '@/router/routes/confirmed-scientific-topic'
import uzAsbo from '@/router/routes/uz-asbo'
import examProgramPresentation from '@/router/routes/exam-program-presentation'
import store from '@/store'

Vue.use(VueRouter)

// vue-router 3.1 dan boshlab push() promise qaytaradi va foydalanuvchi turgan
// sahifasiga qayta o'tmoqchi bo'lsa "NavigationDuplicated" bilan rad etadi.
// Loyihadagi $router.push chaqiruvlari .catch() qo'ymagani uchun bu konsolda
// ushlanmagan xato bo'lib chiqadi. Faqat shu holatni yutamiz, qolgan xatolar
// avvalgidek yuqoriga uzatiladi.
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(error => {
    if (error && error.name === 'NavigationDuplicated') return error
    return Promise.reject(error)
  })
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/admin',
      component: () => import('@/layouts/vertical/LayoutVertical.vue'),
      children: [
        ...dashboard,
        ...categorySubject,
        ...directionSectorCode,
        ...country,
        ...direction,
        ...region,
        ...district,
        ...scientificTopics,
        ...confirmedScientificTopicProtocol,
        ...confirmedScientificTopic,
        ...advisorStudents,
        ...organization,
        ...organizations,
        ...period,
        ...users,
        ...user,
        ...me,
        ...applyDocByOrg,
        ...letter,
        ...requestLetters,
        ...uzAsbo,
        ...inbox,
        ...applyDocument,
        ...applicantDocument,
        ...researchAdvisor,
        ...studentList,
        ...notification,
        ...quoteDistribution,
        ...exam,
        ...additionalQuote,
        ...post,
        ...notificationInbox,
        ...applicantDocumentAll,
        ...additionalExam,
        ...monitoring,
        ...orgMonitoring,
        ...attestationWork,
        ...scientificInformation,
        ...allExams,
        ...targetedLetters,
        ...quoteAgreement,
        ...settings,
        ...certificate,
        ...examProgramPresentation,
      ],
    },
    ...front,
    ...pdfViewer,
    {
      path: '',
      component: () => import('@/layouts/full/LayoutFull.vue'),
      children: [
        ...auth,
        ...oneID,
        {
          path: 'pages/miscellaneous/not-authorized',
          name: 'misc-not-authorized',
          component: () => import('@/views/pages/NotAuthorized.vue'),
          meta: {
            layout: 'full',
            resource: 'Auth',
          },
        },
        {
          path: 'error-404',
          name: 'error-404',
          component: () => import('@/views/error/Error404.vue'),
          meta: {
            layout: 'full',
          },
        },
      ],
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach(async (to, _, next) => {
  const isLoggedIn = store.getters['auth/isAuthenticated']
  if (!canNavigate(to) || (to.matched[0]?.path === '/admin' && !isLoggedIn)) {
    if (!isLoggedIn) return next({ name: 'auth-login' })
    return next({ name: 'home' })
  }

  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    return next({ name: 'home' })
  }

  next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
